@if (errorString) {
  <div>
    {{ errorString }}
  </div>
}
@if (loading) {
  <div class="spinner">
    <p-progressSpinner animationDuration="2s" strokeWidth="4">
    </p-progressSpinner>
  </div>
}
@if (activeSection != "reports") {
  <div class="container">
    <!-- <div class="header" style="display: flex;">
    Evaporator
  </div> -->
    <div class="header-buttons">
      <button
        mat-button
        class="header-button"
        [routerLink]="['/dashboard/notifications']"
        [ngClass]="{ active: activeSection === 'notifications' }"
      >
        Notifications
      </button>
      <button
        mat-button
        class="header-button"
        [routerLink]="['/dashboard/machineryStatus']"
        [ngClass]="{ active: activeSection === 'machineryStatus' }"
      >
        Status
      </button>
      <button
        mat-button
        class="header-button"
        [routerLink]="['/dashboard/reports']"
        [ngClass]="{ active: activeSection === 'reports' }"
      >
        Reports
      </button>
    </div>
    @if (activeSection === "notifications") {
      <div class="list-container">
        @for (notification of notifications; track notification) {
          <div class="list-item" (click)="openNotification(notification)">
            <div class="notification-machine-name">
              {{ notification.machineName }}
            </div>
            <div style="display: flex">
              <div style="display: flex" class="warning-chip">
                <img
                  src="assets/icons/16px_warning-sign.svg"
                  style="margin-right: 10px"
                />
                <div style="color: #692c01">Attention</div>
                <div style="font-weight: 400; margin-left: 16px; width: 200px">
                  {{ notification.timestamp | timeAgo }}
                </div>
              </div>
            </div>
            <div class="notification-title">
              {{ notification.title }}
            </div>
          </div>
        }
      </div>
    }
    @if (activeSection === "machineryStatus") {
      <div class="machine-overview">
        @for (machine of machines; track machine) {
          <div class="machine-list-item" (click)="openMachine(machine)">
            <div class="machine-item">
              <div style="display: flex; align-items: center">
                {{ machine.name }}
              </div>
              <div class="align-right">
                @if (machine.displayStatus === -1) {
                  <mat-icon class="status-icon" style="color: #999"
                    >circle</mat-icon
                  >
                }
                @if (machine.displayStatus === 0) {
                  <mat-icon class="status-icon" style="color: #15bd5e"
                    >circle</mat-icon
                  >
                }
                @if (machine.displayStatus && machine.displayStatus > 0) {
                  <mat-icon class="status-icon" style="color: #fc4b53"
                    >circle</mat-icon
                  >
                }
              </div>
            </div>
          </div>
        }
      </div>
    }

    <div class="footer">
      <button mat-button class="footer-button" [routerLink]="['/about']">
        App About
      </button>
    </div>
  </div>
} @else {
  <app-reports></app-reports>
}
